import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editProfile, listProfile } from "../Redux/Actions/ProfileActions";
import { listCategories } from "../Redux/Actions/CategoryActions";
import { getSubscriptionDetails } from "../Redux/Actions/SubscriptionActions";
import { getCurrentLocation } from "../Redux/Actions/CurrentLocationActions";

const UserDataLoader = ({ userInfo, children }) => {
  const dispatch = useDispatch();

  const { recordItem: editedProfile } = useSelector(
    (state) => state.profileEdit,
  );
  const { profiles } = useSelector((state) => state.profileList);
  const { recordItems: categories } = useSelector(
    (state) => state.categoryList,
  );
  const currentLocation = useSelector(
    (state) => state.currentLocation?.location,
  );

  // GET CATEGORIES
  useEffect(() => {
    if (!categories || categories.length === 0) dispatch(listCategories());
  }, []);

  // ************************************************************
  // GET CURRENT SUBSCRIPTION DETAILS FOR LOGGED IN BUSINESS USER
  // ************************************************************
  useEffect(() => {
    if (userInfo?.profile === "Business") {
      const businessId = userInfo.businessId?.split("#")[1];
      if (businessId) dispatch(getSubscriptionDetails(businessId));
    }
  }, [dispatch, userInfo]);

  // *************************
  // GET CURRENT USER LOCATION
  // *************************
  useEffect(() => {
    if (!currentLocation) {
      console.log("get current location...");
      dispatch(getCurrentLocation());
    }
  }, [dispatch, currentLocation]);

  // **********************************************
  // GET ALL BUSINESSES PROFILES FOR CURRENT COUNTRY
  // **********************************************
  useEffect(() => {
    if (currentLocation && (!profiles || profiles.length === 0)) {
      dispatch(
        listProfile({
          country: currentLocation.country,
          province: currentLocation.state,
        }),
      );
    }
    // Only run this when currentLocation changes (not profiles)
  }, [dispatch, currentLocation]);

  // ***************************************
  // GET CURRENT LOGGED IN BUSINESS PROFILE
  // ***************************************
  useEffect(() => {
    if (userInfo?.profile === "Business" && !editedProfile) {
      const businessId = userInfo.businessId?.split("#")[1];
      if (businessId) dispatch(editProfile(businessId));
    }
  }, [dispatch, userInfo, editedProfile]);

  return children;
};

export default UserDataLoader;
